import { useQuery } from '@tanstack/react-query'
import supabase from 'sdk/api'

const fetchNotifications = async (userId: string) => {
  const { data, error } = await supabase
    .from('notifications')
    .select(`
      *,
      products(*, store_owners_profile(*)),
      booking_transactions(*, services(*)) 
    `)
    .eq('user_id', userId)
    // .eq('is_active', true)
    .order('created_at', { ascending: false })

  if (error) throw error
  return data
}

export const useUserNotifications = (userId?: string) => {
  return useQuery({
    queryKey: ['notifications', userId],
    queryFn: () => fetchNotifications(userId || ''),
    enabled: !!userId
  })
}